"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Workflow = void 0;
class Workflow {
    constructor(data) {
        if (data) {
            this.deserialize(data);
        }
    }
    deserialize(input) {
        var _a;
        Object.assign(this, input);
        this.id = input.id || input._id;
        this.rules = ((_a = input.rules) === null || _a === void 0 ? void 0 : _a.map((rule) => rule)) || [];
        return this;
    }
}
exports.Workflow = Workflow;
